import { BaseFunctionService } from './BaseFunctionService';

export interface IAutenticacaoRfidResult {
     pessoa_id: number;
     organizacao_id: number;
     nome: string;
     tipo_pessoa: string;
     saldo: number;
}

/**
 * Serviço para funções relacionadas ao RFID
 */
export class RfidFunctionsService extends BaseFunctionService {
     
     /**
      * Autentica um código RFID e retorna dados da pessoa
      */
     async autenticarRfid(codigoRfid: string): Promise<IAutenticacaoRfidResult[]> {
          return await this.rpc('autenticar_rfid', { p_codigo: codigoRfid });
     }

     /**
      * Gerencia RFID de uma pessoa (criar, atualizar, remover)
      */
     async gerenciarRfid(pessoaId: number, usuarioAdminId: number, codigoRfid?: string): Promise<boolean> {
          return await this.rpc('gerenciar_rfid', {
               p_pessoa_id: pessoaId,
               p_usuario_admin_id: usuarioAdminId,
               p_codigo_rfid: codigoRfid
          });
     }
}

// Instância singleton
export const rfidFunctionsService = new RfidFunctionsService();
